import api from '@pray/shared/utils/api';

import type { DeleteGroupResponse } from './types';

const GROUPS_URL = '/web/studio/admin/seed-emails/groups';

/**
 * Deletes a group and keeps its seeds. `released_seed_count` is how many probes went back to being
 * ungrouped, which is the number the confirmation names so nobody fears losing mailboxes.
 */
export async function deleteGroup(groupId: string) {
  const res = await api.executeDeleteRequest<{ data: DeleteGroupResponse }>(`${GROUPS_URL}/${groupId}`);
  return res.data.data;
}
